import React, { Component } from "react";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import KurdishSoraniNumbersToWords from "kurdish-numbers-to-words/Sorani.js";
import "../AllPrint.css";
import { FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
class RentPrintKurdish extends Component {
 render() {
  const {
   lang,
   change_Lang,
   rent_invoice_obj,
   user,
   thirdcolor,
   primary_logo,
   index_rentcontrct,
   footer_logo,
   name_krd,
  } = this.props;
  // Kurdish
  let numberWordsSorani1 =
   rent_invoice_obj.introduction !== undefined &&
   rent_invoice_obj.introduction !== null
    ? KurdishSoraniNumbersToWords.convert(
       parseFloat(rent_invoice_obj.introduction.toString().replace(/,/g, ""))
      )
    : 0;
  let numberWordsSorani2 =
   rent_invoice_obj.paymentmonth !== undefined &&
   rent_invoice_obj.paymentmonth !== null
    ? KurdishSoraniNumbersToWords.convert(
       parseFloat(rent_invoice_obj.paymentmonth.toString().replace(/,/g, ""))
      )
    : 0;
  let numberWordsSorani3 =
   rent_invoice_obj.feelate !== undefined && rent_invoice_obj.feelate !== null
    ? KurdishSoraniNumbersToWords.convert(
       parseFloat(rent_invoice_obj.feelate.toString().replace(/,/g, ""))
      )
    : 0;
  let numberWordsSorani4 =
   rent_invoice_obj.safly !== undefined && rent_invoice_obj.safly !== null
    ? KurdishSoraniNumbersToWords.convert(
       parseFloat(rent_invoice_obj.safly.toString().replace(/,/g, ""))
      )
    : 0;

  return (
   <>
    <div className={` ${lang !== "en" ? "fk" : "fkp"}`}>
     <div className="row ">
      <div className="col-12">
       <div className="conn content-containers" id="tbls">
        <div class="row">
         <div class="col-12  ">
          <img
           src={primary_logo}
           style={{ width: "100%" }}
           alt="logo"
           className="img-fluid img-responsive"
          />
         </div>
        </div>
        <div class="row mt-1">
         <div class="col-4">
          <p
           style={{
            fontSize: "22px",
            color: "#000",
            textAlign: "right",
            fontWeight: "bold",
           }}
           class=" text-uppercase"
          >
           &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
           <Time
            value={rent_invoice_obj.createdAt}
            format="YYYY-MM-DD"
            style={{
             fontSize: "22px",
             color: "#000",
             fontWeight: "bold",
            }}
           />
          </p>
         </div>
         <div class="col-4 d-flex justify-content-center">
          <p
           style={{
            fontSize: "25px",
            color: "#000",
            fontWeight: "bolder",
           }}
           class={`d-flex justify-content-center text-uppercase ${
            lang !== "en" ? "fk" : "fkp"
           } `}
          >
           ({change_Lang("Rental contract")})
          </p>
         </div>
         <div class="col-4 text-right">
          <p
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
           class=" text-uppercase"
          >
           {change_Lang("contract number")} #&nbsp;
           {rent_invoice_obj.InvoiceNO}&nbsp;
          </p>
         </div>
        </div>
        <div class="row">
         <div class="col-12">
          <div class="form-group row form-inline">
           <label
            style={{
             fontSize: "23px",
             color: "black",
             fontWeight: "bolder",
            }}
            class="col-sm-3 col-form-label d-flex justify-content-start fkk"
           >
            لایەنی یەکەم(خاوەن موڵك):
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {rent_invoice_obj.firstname}
            </label>
           </div>
           <label
            style={{
             fontSize: "25px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk d-flex justify-content-start"
           >
            لايەنى دووەم (کرێچی):
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {rent_invoice_obj.tenantId && rent_invoice_obj.tenantId.secondname}
            </label>
           </div>
           {/* phone */}
           {/* <label
                        style={{
                          fontSize: "23px",
                          color: "black",
                          fontWeight: "bold",
                        }}
                        class="col-sm-3 col-form-label fkk d-flex justify-content-start"
                      >
                        ژمارەی مۆبایل:
                      </label>
                      <div class="col-sm-3">
                        <label
                          class="d-flex justify-content-start"
                          style={{ fontWeight: "bold", fontSize: "18px" }}
                        >
                          {rent_invoice_obj.phone1}
                        </label>
                      </div>
                      <label
                        style={{
                          fontSize: "23px",
                          color: "black",
                          fontWeight: "bold",
                        }}
                        class="col-sm-3 col-form-label fkk d-flex justify-content-start"
                      >
                        ژمارەی مۆبایل:
                      </label>
                      <div class="col-sm-3">
                        <label
                          class="d-flex justify-content-start"
                          style={{ fontWeight: "bold", fontSize: "18px" }}
                        >
                          {rent_invoice_obj.tenantId &&
                            rent_invoice_obj.tenantId.phone2}
                        </label>
                      </div> */}
           <label
            style={{
             fontSize: "25px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk d-flex justify-content-start"
           >
            {" "}
            {change_Lang("first_rule_place")}:
           </label>
           <br />
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {rent_invoice_obj.available_id &&
              rent_invoice_obj.available_id.Place_ku}
            </label>
           </div>

           <label
            style={{
             fontSize: "25px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk d-flex justify-content-start"
           >
            {change_Lang("Type of property")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {change_Lang(
              rent_invoice_obj.available_id &&
               rent_invoice_obj.available_id.Property
             )}
            </label>
           </div>
           {/* Area */}
           <label
            style={{
             fontSize: "25px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk d-flex justify-content-start"
           >
            {" "}
            {change_Lang("Number of property")}:
           </label>

           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {rent_invoice_obj.available_id &&
              rent_invoice_obj.available_id.NOoFProperty}
            </label>
           </div>

           <label
            style={{
             fontSize: "25px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk d-flex justify-content-start"
           >
            {change_Lang("Area")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {rent_invoice_obj.available_id &&
              rent_invoice_obj.available_id.Area}
             &nbsp;م<sup>2</sup>
            </label>
           </div>
          </div>

          <p
           style={{
            fontSize: "22px",
            color: "#fff",
            fontWeight: "bold",
            borderRadius: "50px 0px 0px 0px",
           }}
           id="liniar"
           class="my-1 d-flex justify-content-center fk"
          >
           {change_Lang("agreement")}
          </p>
         </div>
        </div>
        <div className="row">
         <div className="col-12">
          <table className="table">
           <tbody>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
             className="p-0 m-0"
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              1-
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              لایەنی یەکەم ڕەزامەندە لەسەر بەکرێدانی ئەم موڵکە کە لە سەرەوە
              ئاماژەی پێکراوە بەلایەنی دووەم.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              2-
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              ماوەی ئەم گرێبەستە (
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={rent_invoice_obj.rental}
               style={{}}
               className="text-center"
              />
              )مانگە دەستپێدەکات لە بەرواری&nbsp;(
              <Time
               value={rent_invoice_obj.startdate}
               format="YYYY-MM-DD"
               style={{
                color: "black",
               }}
              />
              )&nbsp;تا&nbsp; (
              <Time
               value={rent_invoice_obj.enddate}
               format="YYYY-MM-DD"
               style={{
                color: "black",
               }}
              />
              )&nbsp;وە لەکاتی کۆتایی هاتنی ماوەی ئاماژە پێکراو لەسەر لایەنی
              دووەمە کە شوینی بەکرێگیراو چۆل بکات بی ئەوەی پێویستی بە ئاگادار
              کردنەوەی هەبێت.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              3-
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              هەردوو لایەن رەزامەندن لەسەر کرێی مانگانەی بە بڕی &nbsp;{" "}
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={rent_invoice_obj.paymentmonth}
               style={{}}
               className="text-center"
               prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
              />
              &nbsp;
              {numberWordsSorani2}
              {lang === "en" && rent_invoice_obj.currency === "dolar"
               ? "($)"
               : lang === "krd" && rent_invoice_obj.currency === "dolar"
               ? "(دۆلار)"
               : lang === "arb" && rent_invoice_obj.currency === "dolar"
               ? "(دولار)"
               : lang === "en" && rent_invoice_obj.currency !== "dolar"
               ? "(ID)"
               : lang === "krd" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : lang === "arb" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : ""}
              .
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              4-
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              من لایەنی دووەم پابەندم بە پێدانی کرێیەکە &nbsp;(
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={rent_invoice_obj.MonthForRent}
               className="text-center"
              />
              )&nbsp;مانگ جارێک پێشەکی.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              5-
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              لایەنی دووەم بڕی &nbsp;
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={rent_invoice_obj.introduction}
               style={{}}
               prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
               className="text-center"
              />
              &nbsp;
              {numberWordsSorani1}
              {lang === "en" && rent_invoice_obj.currency === "dolar"
               ? "($)"
               : lang === "krd" && rent_invoice_obj.currency === "dolar"
               ? "(دۆلار)"
               : lang === "arb" && rent_invoice_obj.currency === "dolar"
               ? "(دولار)"
               : lang === "en" && rent_invoice_obj.currency !== "dolar"
               ? "(ID)"
               : lang === "krd" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : lang === "arb" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : ""}
              دەدات بە لایەنی یەکەم وەک پێشەکی (
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={rent_invoice_obj.Monthintroduction}
               className="text-center"
              />
              ) مانگ.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              6-
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              لایەنی دووەم پاپەند دەبیت بە پێدانی بڕی &nbsp;
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               style={{}}
               value={rent_invoice_obj.safly}
               className="text-center"
               prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
              />
              &nbsp;
              {numberWordsSorani4}
              {lang === "en" && rent_invoice_obj.currency === "dolar"
               ? "($)"
               : lang === "krd" && rent_invoice_obj.currency === "dolar"
               ? "(دۆلار)"
               : lang === "arb" && rent_invoice_obj.currency === "dolar"
               ? "(دولار)"
               : lang === "en" && rent_invoice_obj.currency !== "dolar"
               ? "(ID)"
               : lang === "krd" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : lang === "arb" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : ""}
              &nbsp;وەك دلنيايى(تأمینات) بە {name_krd} وه پێویستە لەسەر کرێچی کە
              پسولەی ئەسلی پێبێت بۆ داناوەی تەئمینات به مەرجيك لايەنى دووەم
              مۆڵكەكه بەبى بوونى هيج كەم و كوڕيەك رادەست بكاتەوه بە پێچەوانەوە
              پارە کە نادرێتەوە لایەنی دووەم.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              7-
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              لایەنی دووەم ئەم مۆلکە بەکاردێنیت بۆ مەبەستی (
              {rent_invoice_obj.perpose}
              )لە کاتی بەکارهێنانی بۆ هەر مەبەستێکی تر پێویستە ئاگاداری{" "}
              {name_krd} بکات و رەزامەندی لایەنی یەکەم بە نوسراوو وەربگریت.بە
              پێچەوانەوە مافی لایەنی یەکەمە ئەم گریبەستە هەڵبوشێنێتەوە بەبی
              ئاگادار کردنەوەی لایەنی دووەم.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              8-
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              لایەنی دووەم بەلێن دەدات کە پارێزگاری لە شوێنی بەکرێگیراو بکات لە
              کاتی سوود وەرگرتن لە شوێنەکە وە دووری بگرێت لە تێکجوون و داڕمان وە
              بەکارنەهێنانی بە شێوەیەکی نەخوازراو.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fk" : "fkp"}`}
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",

               fontSize: "20px",
              }}
              scope="row"
             >
              9-
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              لە بەرواری واژوو کردنی ئەم گرێبەستە خزمەتگوزاریەکانی پرۆژە و
              شارەوانی و کارەبا و ئاو وهەر خزمەت گوزاریەکی تر هەبیت لە ئەستۆی
              لایەنی دووەم دەبیت.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              10-
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               fontSize: "21px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              ئەگەر شوێنی بەکرێگیراو راخراو بوو (مؤثث)لایەنی دووەم پێویستە
              پارێزگاری لە کەل و پەلەکان بکات و لەکاتی چۆل کردنی شوینی
              بەکرێگیراو وەک خۆی رادەستی لایەنی یەکەم بکاتەوە، بە پێچەوانەوە
              لایەنی دووەم بەرپرسە لە چاککردنەوە یان گۆڕینی لەسەر ئەرکی خۆی.
             </td>
            </tr>
           </tbody>
          </table>
         </div>
        </div>
       </div>
       <div className="row content-containers" id="tbls_two">
        <div class="col-12  ">
         <img
          src={primary_logo}
          alt="logo"
          style={{ width: "100%" }}
          className="img-fluid img-responsive"
         />
        </div>
       </div>
       <div className="row">
        <div className="col-12">
         <table className="table">
          <tbody>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             11-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "2px",
              color: "black",
              fontWeight: "bold",
              fontSize: "23px",
              textAlign: "justify",
              borderTop: "none",
             }}
            >
             لایەنی دووەم پابەند دەبێ بە پێدانی کرێ لە کاتی دیاریکراو لەم
             گرێبەستە. لەکاتی دواکەوتن لە (7) رۆژ زیاتر ئەوە بە پێی برگەی (1) لە
             ماددەی 17 (لە یاسای بەکرێدانی موڵك لە قانونی عێراقی ژمارە (87) ساڵی
             1979) مامەڵەی لەگەل دەکرێ ئەویش بە چۆڵ کردنی موڵکەکە و تێچوی
             هۆشداری دادگا ئەکەوێتە ئەستۆی لایەنی دووەم لەگەل کرێی مانگانە.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             12-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "2px",
              color: "black",
              fontWeight: "bold",
              fontSize: "23px",
              textAlign: "justify",
              borderTop: "none",
             }}
            >
             دوای تەواوبونی ماوەی ئەم گرێبەستە ئەگەر لایەنی دووەم پابەند نەبێ بە
             چۆڵکردن یان نوێکردنەوەی ئەم گرێبەستە ئەوا کرێی موڵکەکە دەبێت بە
             رۆژانە بە بڕی &nbsp;(
             <NumberFormat
              displayType="text"
              thousandSeparator={true}
              style={{}}
              value={rent_invoice_obj.feelate}
              className="text-center"
              prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
             />
             &nbsp;
             {numberWordsSorani3}
             {lang === "en" && rent_invoice_obj.currency === "dolar"
              ? "($)"
              : lang === "krd" && rent_invoice_obj.currency === "dolar"
              ? "(دۆلار)"
              : lang === "arb" && rent_invoice_obj.currency === "dolar"
              ? "(دولار)"
              : lang === "en" && rent_invoice_obj.currency !== "dolar"
              ? "(ID)"
              : lang === "krd" && rent_invoice_obj.currency !== "dolar"
              ? "(دینار)"
              : lang === "arb" && rent_invoice_obj.currency !== "dolar"
              ? "(دینار)"
              : ""}
             )&nbsp; بۆ هەر رۆژێک هەژمار دەکرێت تا ئەو کاتەی کێشەکە یەکلایی
             دەبێتەوە.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             13-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "2px",
              color: "black",
              fontWeight: "bold",
              fontSize: "23px",
              textAlign: "justify",
              borderTop: "none",
             }}
            >
             ئەگەر لەماوەی ئەم گرێبەستە خاوەنداریەتی ئەم موڵکە گواسترایەوە بۆ
             هەر لایەنێکی تر ئەوا ئەبێ خاوەنە نوێیەکەی پابەندی نێوەرۆکی ئەم
             گرێبەستە.
            </td>
           </tr>

           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             14-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "2px",
              color: "black",
              fontWeight: "bold",
              fontSize: "23px",
              textAlign: "justify",
              borderTop: "none",
             }}
            >
             هەر یەک لە لایەنی یەکەم و لایەنی دووەم پێوستە بڕی کرێی نیو مانگ بۆ
             هەر ساڵێک بدەن بە {name_krd} لە بڕی رێکخستنی ئەم گرێبەستە.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             15-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "2px",
              color: "black",
              fontWeight: "bold",
              fontSize: "23px",
              textAlign: "justify",
              borderTop: "none",
             }}
            >
             لەکاتی چۆڵکردن شوێنی بەکرێ گیراو پێویستە لایەنی دووەم چۆن موڵکەکەی
             وەرگرتوە وەک خۆی بەبێ کەم و کورتی رادەستی لایەنی یەکەم بکاتەوە،
             بەپێچەوانەوە بەرپرسە لە چاککردنەوەی کەم وکوریەکان بەزوترین کات.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             16-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "2px",
              color: "black",
              fontWeight: "bold",
              fontSize: "23px",
              textAlign: "justify",
              borderTop: "none",
             }}
            >
             لەکاتی نوێ کردنەوەی گرێبەست هەر لایەنێک پابەند دەبێت بە پێدانی کرێی
             نیو مانگ بۆ یەک ساڵ بە {name_krd}.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             17-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "2px",
              color: "black",
              fontWeight: "bold",
              fontSize: "23px",
              textAlign: "justify",
              borderTop: "none",
             }}
            >
             لایەنی دووەم بەهیچ شێوەیەک نابێت ببێتە مایەی ئەزیەت و ئازار بۆ
             دراوسێیەکانی و بە پێچەوانەوە بەرپرسیار دەبێت و گرێبەستەکە
             هەڵدەوەشێتەوە.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             18-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "2px",
              color: "black",
              fontWeight: "bold",
              fontSize: "23px",
              textAlign: "justify",
              borderTop: "none",
             }}
            >
             لەکاتی چارەسەر نەبوونی کێشەی لایەنی یەکەم و دووەم بە شێوازی گفتوگۆ
             و دانوستاندن ئەوا {name_krd}&nbsp; بەرپرس نیە و نابێت بەڵکو پێویستە
             لەسەر لایەنەکان کێشەکە چارەسەر بکەن بەگرتنەبەری رێکاری یاسایی و
             پەنابردن بۆ دادگای تایبەت.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             19-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "2px",
              color: "black",
              fontWeight: "bold",
              fontSize: "23px",
              textAlign: "justify",
              borderTop: "none",
             }}
            >
             لەسەر لایەنی دووەم پێوسیتە خاوەن موڵک یان عقارات ادریس علی قادر
             ئاگادار بکاتەوە مانگێک پێش دەرچوون یان کۆتای هاتنی گرێبەستەکە.
            </td>
           </tr>
          </tbody>
         </table>
        </div>
       </div>
       <div className="form-inline">
        <p
         style={{
          fontSize: "18px",
          color: "black",
          fontWeight: "bold",
          textAlign: "center",
         }}
        >
         {change_Lang("note")}&nbsp;:{rent_invoice_obj.note}
        </p>
       </div>
       <br /> <br />
       <div className="row">
        <div className="form-group d-flex justify-content-center col-3">
         <label
          style={{
           fontSize: "22px",
           color: "#000",
           fontWeight: "bold",
          }}
          className="form-label"
         >
          لایەنی یەکەم (خاوەن)
         </label>
        </div>
        <div className="col-3">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           شاهێد
          </label>
         </div>
        </div>
        <div className="col-3">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           شاهێد
          </label>
         </div>
        </div>
        <div className="col-3 d-flex justify-content-center">
         <div className="form-group ">
          <label
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           لایەنی دووەم (کرێچی)
          </label>
         </div>
        </div>
       </div>
       <div className="row">
        <div className="col-3 form-group d-flex justify-content-center">
         <label
          style={{
           fontSize: "22px",
           color: "#000",
           fontWeight: "bold",
          }}
          className="form-label"
         >
          {rent_invoice_obj.firstname}
         </label>
        </div>
        <div className="col-3">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           {rent_invoice_obj.witness1}
          </label>
         </div>
        </div>
        <div className="col-3">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           {rent_invoice_obj.witness2}
          </label>
         </div>
        </div>
        <div className="col-3 d-flex justify-content-center">
         <div className="form-group ">
          <label
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           {rent_invoice_obj.tenantId && rent_invoice_obj.tenantId.secondname}
          </label>
         </div>
        </div>
       </div>
      </div>
     </div>
    </div>
    {/* footer */}
    <div
     className="row"
     style={{
      position: "fixed",
      bottom: 47,
      width: "100%",
     }}
    >
     <div className="col-8 d-flex justify-content-end">
      <label
       style={{
        fontSize: 22,
        color: "#000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
       }}
       className="fk"
      >
       {rent_invoice_obj.branchId ? rent_invoice_obj.branchId.adress : ""}
       &nbsp;&nbsp;
       <FaMapMarkerAlt
        style={{
         color: "#fff",
         background: " #000",
         padding: 5,
         fontSize: 25,
        }}
       />
      </label>
     </div>
     <div className="col-4 d-flex justify-content-end">
      <h4
       style={{
        fontSize: 21,
        color: "#black",
        letterSpacing: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        direction: "ltr",
        lineHeight: 1.5,
       }}
      >
       <FaPhoneAlt
        style={{
         color: "#fff",
         background: " #000",
         padding: 5,
         fontSize: 25,
         marginRight: 20,
        }}
       />
       {rent_invoice_obj.branchId
        ? rent_invoice_obj.branchId.adressNumber1
        : ""}{" "}
       <br />{" "}
       {rent_invoice_obj.branchId
        ? rent_invoice_obj.branchId.adressNumber2
        : ""}
      </h4>
     </div>
    </div>
    <div
     style={{
      position: "fixed",
      bottom: 0,
      width: "100%",
      zIndex: -1,
     }}
    >
     <img src={footer_logo} alt="logo" width="100%" />
    </div>
   </>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  index_rentcontrct: state.Invoice_Reducer.index_rentcontrct,
  user: state.AuthReducer.user,
  primarycolor: state.HelperReducer.primarycolor,
  secondarycolor: state.HelperReducer.secondarycolor,
  thirdcolor: state.HelperReducer.thirdcolor,
  primary_logo: state.HelperReducer.primary_logo,
  footer_logo: state.HelperReducer.footer_logo,
  name_krd: state.HelperReducer.name_krd,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(RentPrintKurdish);
